module.exports = __webpack_public_path__ + "img/preferences.4752e1f1.png";